import {Component, ElementRef, Input} from '@angular/core';
import {WebsiteSpotPage} from '../../website-spot';

@Component({
    selector: 'hc-evento',
    templateUrl: 'hc-evento.html',
    providers: []
})
export class HcEvento {

    eventosPC = [];
    eventosMobile = [];

    @Input('hpage') hpage: WebsiteSpotPage;
    @Input('blocked') blocked: any;
    @Input('index') index: number;
    @Input('first') first: boolean;

    constructor(public element: ElementRef) {

    }

    ngOnInit() {

        if (this.blocked.Layoute == 2) {

            this.hpage.rootdata.Spotdays.forEach((evento, idx) => {

                if (idx >= 3) {
                    return;
                }

                this.eventosMobile.push(evento);

                if (idx == 1) {
                    this.eventosPC.unshift(evento);
                } else {
                    this.eventosPC.push(evento);
                }

            });

        }

    }

}



// WEBPACK FOOTER //
// ./src/pages/sync/website-spot/components/hc-evento/hc-evento.ts